import Chart from "react-google-charts";
import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import { useNavigate } from 'react-router-dom';


class SectorPerformanceChartWithNavigate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
    console.log('this.props', this.props);
  }

  custom_sort = (a, b) => {
    return parseFloat(b.changesPercentage) - parseFloat(a.changesPercentage);
  }

  componentDidMount() {
    ApiService.getSectorPerformance()
      .then(result => {
        console.log('sector performance', result);
        result.sort(this.custom_sort);
        let filteredData = [];
        filteredData.push(['Sector', 'Changes',  {role: 'annotation'}, {role: 'style' }, {role: 'tooltip'}]);
        for (var i = 0; i < result.length; i++) {
          if (result[i].sector === 'Communication Services') result[i].sector = 'Comm. Services';
          if (result[i].sector === 'Consumer Cyclical') result[i].sector = 'Cons. Cyclical';
          if (result[i].sector === 'Consumer Defensive') result[i].sector = 'Cons. Defensive';
          if (result[i].sector === 'Financial Services') result[i].sector = 'Fin. Services';

          let color = parseFloat(result[i].changesPercentage) < 0 ? '#FF6666' : '#6BA583';
          let tmpPercent = parseFloat(result[i].changesPercentage) < 0 ? -1*parseFloat(result[i].changesPercentage) : parseFloat(result[i].changesPercentage);
          let tmpPercentStr = parseFloat(tmpPercent).toFixed(2) + '%';
          let tooltipTag = result[i].sector + ': ' + parseFloat(result[i].changesPercentage).toFixed(2) + '%';
          
          filteredData.push([result[i].sector, tmpPercent, tmpPercentStr, color, tooltipTag]);
        }
        this.setState({ data: filteredData });
        console.log('filteredData', filteredData, JSON.stringify(filteredData));
        console.log('data', JSON.stringify(this.state.data));
      })
      .catch((error) => {
        console.log(error);
      });

  }

  replaceKeywords(sectorName){
    let result = '';
    if (sectorName === 'Comm. Services') {result = 'Communication Services'};
    if (sectorName === 'Cons. Cyclical') {result = 'Consumer Cyclical'};
    if (sectorName === 'Cons. Defensive') {result = 'Consumer Defensive'};
    if (sectorName === 'Fin. Services') {result = 'Financial Services'};
    return result;
  }

  render() {
    if (this.state === null) {
      return <div>Loading...</div>
    }
    if (this.state.data === null || this.state.data.length <= 0) {
      return <div>No Data</div>
    }
    return (
      <Chart
        width={'330px'}
        height={'370px'}
        chartType="BarChart"
        loader={<div>Loading Chart</div>}
        data={this.state.data}
        options={{
          title: 'Sector Performance',
          chartArea: { left: 110, top: 30, bottom: 40, right: 20, width: '50%', height: '50%' },
          // hAxis: {
          //   title: 'Percentage (%)',
          //   minValue: 0,
          // },
          // vAxis: {
          //   title: '',
          // },
          hAxis: { textPosition: 'none' },
          legend: { position: 'none' },
          isStacked: false,
        }}
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
              const chart = chartWrapper.getChart();
              google.visualization.events.addListener(chart, "select", e => {
                console.log('click', chart.getSelection(), this.props);
                const { row, column } = chart.getSelection()[0];
                console.log('click', chart.getSelection(), row, column, this.state.data[row], this.props);
                let sectorName = this.state.data[row+1][0];
                let result = this.state.data[row+1][0];
                if (sectorName === 'Comm. Services') {result = 'Communication Services'};
                if (sectorName === 'Cons. Cyclical') {result = 'Consumer Cyclical'};
                if (sectorName === 'Cons. Defensive') {result = 'Consumer Defensive'};
                if (sectorName === 'Fin. Services') {result = 'Financial Services'};
                console.log('click sector', result, sectorName);
                this.props.navigate('/screener/country/US/sector/'+ result);
              });
            }
          }
        ]}

        // For tests
        rootProps={{ 'data-testid': '1' }}
      />
    )
  }
}

function SectorPerformanceChart(props) {
  let navigate = useNavigate();
  return <SectorPerformanceChartWithNavigate {...props} navigate={navigate} />
}

export default SectorPerformanceChart;


